export function getSentryDsn(): string | undefined {
  return import.meta.env.VITE_SENTRY_DSN;
}

/** Maps to Sentry/GlitchTip environment (e.g. development, production). */
export function getTelemetryEnvironment(): string {
  return import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE || "development";
}

/** Enabled when a DSN is configured (disabled in test builds and local Vite development). */
export function isTelemetryEnabled(): boolean {
  if (import.meta.env.VITE_TEST === "1") return false;
  if (import.meta.env.MODE === "development") return false;
  return Boolean(getSentryDsn());
}
